import { SliceLayerTypes } from "../config/config";
import { PALETTE_LENGTH } from "../canvas/canvasUtils";

export function getMeasurementData(index, sliceCurrent, sliceInfo) {
  let floor = Math.floor(index);
  if (index !== floor) {
    let rem = index - floor;
    index = floor;
    if (rem > 0.5) ++index;
  }

  if (sliceCurrent && sliceInfo) {
    let thickness = sliceCurrent.sliceSegmentationThicknessData;
    if (!thickness) return;

    let layerData = sliceCurrent.sliceSegmentationLayerData;
    if (!layerData) return;

    let ilm = layerData[SliceLayerTypes.Ilm];
    let rpe = layerData[SliceLayerTypes.Rpe];
    if (!ilm || !rpe) return;

    let yInPerPx = 1 / sliceInfo.dimensions.verticalResolution;
    let mmPerIn = 25.4;
    let umPerMm = 1000;
    let text = (yInPerPx * mmPerIn * umPerMm * thickness[index]).toFixed(2);

    return {
      index,
      thickness: thickness[index],
      ilm: ilm[index],
      rpe: rpe[index],
      convertedThickness: (yInPerPx * mmPerIn * umPerMm * thickness[index]),
      thicknessText: text + " μm"
    }
  }
  return null;
}

export function getDefaultMeasurementIndex(sliceInfo) {
  let width = sliceInfo.dimensions && sliceInfo.dimensions.pixelWidth || sliceInfo.pixelWidth || 0;
  return width / 2;
}

export function calculateThicknessMapAdjustment(minThicknessUm, maxThicknessUm, depthSpacingMm){
  let minMm = minThicknessUm / 1000.0;
  let maxMm = maxThicknessUm / 1000.0;
  let thicknessRangeMm = maxMm - minMm;
  let maxIndex = PALETTE_LENGTH - 1;
  let thicknessScale = maxIndex / thicknessRangeMm;
  let spacingMm = depthSpacingMm;
  let slope = spacingMm * thicknessScale;
  let offset = minMm / spacingMm * -1;

  return { slope, offset };
}

export function getThicknessMapSize(context) {
  let minX = 0.5, maxX = 0.5, minY = 0.5, maxY = 0.5;

  if (context.sliceInfo) {
    minX = Math.min(minX, context.sliceBounds.minX);
    maxX = Math.max(maxX, context.sliceBounds.maxX);
    minY = Math.min(minY, context.sliceBounds.minY);
    maxY = Math.max(maxY, context.sliceBounds.maxY);
  }
  if (context.compositeInfo) {
    minX = Math.min(minX, context.compositeBounds.minX);
    maxX = Math.max(maxX, context.compositeBounds.maxX);
    minY = Math.min(minY, context.compositeBounds.minY);
    maxY = Math.max(maxY, context.compositeBounds.maxY);
  }

  return { w: maxX - minX, h: maxY - minY };
}

export function setOCTButtonText(exam, eye = "") {
  if (eye == "") 
  {
    if (exam.odGroups.length > 0) {
      // Only cirrus exams have eye type appended to groupSeriesType text. Append eye for other types
      if (exam.odGroups[0].browserType != 1)
        setButtonTextWithEye(exam, exam.odGroups[0]);
      else
        setButtonText(exam, exam.odGroups[0]);
    }
    else if (exam.osGroups.length > 0) {
      if (exam.osGroups[0].browserType != 1)
        setButtonTextWithEye(exam, exam.osGroups[0]);
      else
        setButtonText(exam, exam.osGroups[0]);
    }
  }
  else 
  {
    if (exam.odGroups.length > 0 && eye == "OD") {
      // Only cirrus exams have eye type appended to groupSeriesType text. Append eye for other types
      if (exam.odGroups[0].browserType != 1)
        setButtonTextWithEye(exam, exam.odGroups[0]);
      else
        setButtonText(exam, exam.odGroups[0]);
    }
    else if (exam.osGroups.length > 0 && eye == "OS") {
      if (exam.osGroups[0].browserType != 1)
        setButtonTextWithEye(exam, exam.osGroups[0]);
      else
        setButtonText(exam, exam.osGroups[0]);
    }
  }
}

function setButtonText(exam, groupItem) 
{
  exam.octDateButtonText = exam.dateDisplay + " - " + groupItem.groupSeriesType + " (" + exam.exSrNo + ")";
}

function setButtonTextWithEye(exam, groupItem) 
{
  exam.octDateButtonText = exam.dateDisplay + " - " + groupItem.eye + " " + groupItem.groupSeriesType + " (" + exam.exSrNo + ")";
}